import { render, staticRenderFns } from "./CadastroTerceiros.vue?vue&type=template&id=97dd4d64&scoped=true&"
import script from "./CadastroTerceiros.vue?vue&type=script&lang=js&"
export * from "./CadastroTerceiros.vue?vue&type=script&lang=js&"
import style0 from "./CadastroTerceiros.vue?vue&type=style&index=0&id=97dd4d64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97dd4d64",
  null
  
)

export default component.exports